import { BackgroundGradientAnimation } from '@/components/AnimatedCosGradientBg'
import AudioPlayer from '@/components/custom-components/AudioPlayer/AudioPlayer'
import { SidebarProvider } from '@/components/shadcn/sidebar'
import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useLocalStorage } from 'usehooks-ts'

export const Route = createFileRoute('/popout-audio')({
  component: PopoutAudio,
})

function PopoutAudio() {
  const [, setIsPopoutOpen] = useLocalStorage<boolean>('audioPopoutOpen', false)

  useEffect(() => {
    const unloadHandler = () => {
      setIsPopoutOpen(false)
    }
    window.addEventListener('beforeunload', unloadHandler)
    return () => {
      window.removeEventListener('beforeunload', unloadHandler)
    }
  }, [setIsPopoutOpen])

  return (
    <SidebarProvider>
      <div className=" bg-white w-screen h-screen flex justify-center items-center">
        <BackgroundGradientAnimation>
          <div className="max-w-[35rem] w-full">
            <AudioPlayer isPopout />
          </div>
        </BackgroundGradientAnimation>
      </div>
    </SidebarProvider>
  )
}

export default PopoutAudio
